var normalizeEntities = function normalizeEntities(removeInvalidLayouts, removeLayoutsWithoutColumnNumbers, changeDuplicatedCustomLayouts, changeDuplicatedCurrentLayouts, removeInvalidFields, changeCustomLayoutsCalledDefault) {
  return function (response) {
    var entities0 = response.userEntities || [];
    var entities1 = removeInvalidLayouts(entities0);
    var entities2 = removeLayoutsWithoutColumnNumbers(entities1);
    var entities3 = changeDuplicatedCustomLayouts(entities2);
    var entities4 = changeDuplicatedCurrentLayouts(entities3);
    var entities5 = removeInvalidFields(entities4);
    return changeCustomLayoutsCalledDefault(entities5);
  };
};

export { normalizeEntities };
//# sourceMappingURL=normalize-entities.esm.js.map
